// extracted by mini-css-extract-plugin
module.exports = {"enabled":"SbuViewTable_enabled__tJpHn","disabled":"SbuViewTable_disabled__3CwhU"};